import "./PressPage.scss";
import {mobileState} from "../../state/atoms";
import { useRecoilValue } from "recoil";
import { useEffect, useState } from "react";

export default function PressPage() {
  const mobile = useRecoilValue(mobileState);
  const [showAllNews, setShowAllNews] = useState(true);

  useEffect(() => {
    if (mobile) {
      setShowAllNews(false);
    } else {
      setShowAllNews(true);
    }
  }, [mobile])

  const articleItem = (thumbURL: string, logoURL: string = "", title: string, date: string, articleURL: string, logoBg = "") => {
    return (
    <div className="item">
      <a href={articleURL} target="_blank" rel="noreferrer">
        <div className="graphic" style={{backgroundImage: `url("${thumbURL}")`}}>
          <div className="graphic-overlay"/>
          {logoURL && <div className="logo">
            <img className={logoBg === "black" ? 'black-bg' : logoBg === "white" ? 'white-bg' : ''} src={logoURL} alt="Article logo"/>
          </div>}
        </div>
      </a>
      <div className="title">{title}</div>
      <div className="date">{date}</div>
      <div className="read-more">
        <a href={articleURL} target="_blank" rel="noreferrer">Read More &gt;</a>
      </div>
    </div>
    )
  }

  return (
    <main className="press-content">
      <section className="one">
        <div className="content">
          <h1>Press Releases</h1>
          <div className="article-preview">
            <div className="flex">
              <div className="img">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/DSARed.svg" alt='DSA'/>
              </div>
              <div className="text">
                <h2>Introducing<br className="mobile-only"/> MustHaveMenus Display: </h2>
                <h3>Simplifying Restaurant Marketing by Seamlessly Integrating Display Management with Menu Design</h3>
                <p className="date">February 6, 2024</p>
              </div>
            </div>
            <div>
              <p><b>BEND, OR:</b> Today, MustHaveMenus, the all-in-one platform for restaurant marketing, is thrilled to announce the launch of <a href="/feature/digital-menu-board-solution.html">MustHaveMenus Display</a>, a groundbreaking digital display management system that seamlessly integrates with MustHaveMenus' best-in-class menu maker and design tool.</p>

              <p>This innovative addition gives restaurants a natural link between the creative process and customer touchpoints. When a restaurant makes changes to its brand, menu items or promotions they can be instantly updated on display systems across many screens and locations. Plus, the power of MustHaveMenus' custom design app creates endless potential for engaging multimedia content.</p>
            </div>

            <div className="read-btn-container">
              <a href="/content/press/display-app-announcement" className="ant-btn ant-btn-primary ant-btn-lg">Read the full release</a>
            </div>
          </div>
        </div>
      </section>

      <section className="two">
        <div className="content">
          <h3>Previous Press Releases</h3>
          <div className="flex articles mhm-press">
            <div className="item">
              <a href="/content/press/toast-integration-announcement" target="_blank" rel="noreferrer">
                <div className="graphic">
                  <img src="https://timber.mhmcdn.com/site/content/press/MHM&Toast.svg" alt="MHM x Toast"/>
                </div>
              </a>
              <div className="title">MustHaveMenus Joins Toast Partner Ecosystem</div>
              <div className="date">September 14, 2023</div>
              <div className="read-more">
                <a href="/content/press/toast-integration-announcement">Read More &gt;</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="three">
        <div className="content">
          <h1>In the News</h1>
          <div className="desktop-only">
            <div className="flex nyt">
              <div className="img">
                <img src="https://timber.mhmcdn.com/site/content/press/NYTArticleThumb.webp" alt="NYT Article"/>
              </div>
              <div className="text">
                <img src="https://timber.mhmcdn.com/site/content/press/NYTLogo.webp" alt="NYT Logo"/>
                <h2>The QR-Code Menu Is Being Shown the Door</h2>
                <div className="date">May 22, 2023</div>
                <p>A dining innovation that once looked like the future has worn out its welcome with many restaurateurs, customers and servers who say it takes the joy out of dining.</p>
                <a className="ant-btn ant-btn-primary ant-btn-lg" href="https://www.nytimes.com/2023/05/22/dining/restaurant-qr-code-menu.html" target="_blank" rel="noreferrer">Read More</a>
              </div>
            </div>
          </div>

          <div className="flex articles">
            {mobile &&
            articleItem("https://timber.mhmcdn.com/site/content/press/NYTArticleThumb.webp", 
            "https://timber.mhmcdn.com/site/marketing/icons/NYTLogoWhite.svg", 
            "The QR-Code Menu Is Being Shown the Door", 
            "May 22, 2023", 
            "https://www.nytimes.com/2023/05/22/dining/restaurant-qr-code-menu.html",
            "black")}
            {articleItem("https://timber.mhmcdn.com/site/content/press/QSRThumb2.webp", 
            "https://timber.mhmcdn.com/site/content/press/PMQLogo.png", 
            "How to Design an Exceptional—and Moneymaking—Digital Menu Board for Your Pizzeria", 
            "January 29, 2025", 
            "https://www.pmq.com/how-to-design-an-exceptional-and-moneymaking-digital-menu-board-for-your-pizzeria/",
            "white")}
            {articleItem("https://timber.mhmcdn.com/site/content/press/QSRThumb3.webp", 
            "https://timber.mhmcdn.com/site/content/press/QSRLogo.svg", 
            "How to Design an Engaging Digital Menu Board", 
            "January 27, 2025", 
            "https://www.qsrmagazine.com/story/how-to-design-an-engaging-digital-menu-board/")}

            {!showAllNews && 
            <div className="mobile-only ant-btn view-more-btn" onClick={() => setShowAllNews(true)}>View More</div>}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/BAndRThumb2.webp", 
            "https://timber.mhmcdn.com/site/content/press/BandRLogo.svg", 
            "5 Ways Digital Menu Boards Can Help Your Restaurant", 
            "September 26, 2024", 
            "https://www.barandrestaurant.com/technology/5-ways-digital-menu-boards-can-help-your-restaurant")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/FSRThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/FSRLogo.svg", 
            "Creating a Positive Restaurant Culture: Tips to Retain Top Talent", 
            "April 25, 2023", 
            "https://www.fsrmagazine.com/expert-takes/creating-positive-restaurant-culture-tips-retain-top-talent")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/BandRThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/BandRLogo.svg", 
            "5 Lessons to Learn From Wildly Successful Restaurants", 
            "May 18, 2023", 
            "https://www.barandrestaurant.com/chains/5-lessons-learn-wildly-successful-restaurants")}

            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/CandybarBlogThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/CandybarBlogLogo.png", 
            "How to Create a QR Code Menu to Boost Restaurant Sales", 
            "May 23, 2023", 
            "https://www.candybar.co/how-to-create-a-qr-code-menu-to-boost-restaurant-sales/",
            "white")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/FIEThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/FIELogo.png", 
            "MustHaveMenus", 
            "May 23, 2023", 
            "https://products.foodindustryexecutive.com/collections/software/products/software-musthavemenus")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/RestoLabsThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/RestoLabsLogo.png", 
            "Should You Overhaul Your Takeout Menu?", 
            "May 18, 2023", 
            "https://www.restolabs.com/blog/takeout-menu",
            "white")}

            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/WTNThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/WTNLogo.svg", 
            "10 Ways Tea Cafés and Shops Can Use Digital Signage to Inform & Entertain Guests", 
            "April 19, 2023", 
            "https://www.worldteanews.com/retail/10-ways-tea-cafes-and-shops-can-use-digital-signage-inform-entertain-guests")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/MRMThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/MRMLogo.svg", 
            "What Guests Lose in the Ghost Kitchen Experience", 
            "January 6, 2023", 
            "https://modernrestaurantmanagement.com/what-guests-lose-in-the-ghost-kitchen-experience/")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/RestaurantNewsThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/RestaurantNewsLogo.webp", 
            "MustHaveMenus Offers Free Holiday Menu Templates", 
            "November 22, 2022", 
            "https://www.restaurantnews.com/musthavemenus-offers-free-holiday-menu-templates-112222/")}

            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/GanjapreneurThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/GanjapreneurLogo.webp", 
            "MustHaveMenus Offers Free Dispensary Menu Templates", 
            "July 26, 2022", 
            "https://www.ganjapreneur.com/musthavemenus-offers-free-dispensary-menu-templates/")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/TodaysRestaurantThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/TodaysRestaurantLogo.png", 
            "7 Ways Restaurants Can Cut Costs in 2022", 
            "February 18, 2023", 
            "https://trnusa.com/7-ways-restaurants-can-cut-costs-in-2022-by-mark-plumlee-restaurants-operate-in-a-famously-low-margin-industry-that-margin-has-never-been-more-precariously-thin-than-right-now-not-only-are-fewer-p/",
            "white")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/DashTechThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/DashTechLogo.png", 
            "How to Refresh Your Marketing in 2023", 
            "March 27, 2023", 
            "https://www.dashtech.org/how-to-refresh-your-marketing-in-2023/",
            "white")}

            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/FSBThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/FSBLogo.svg", 
            "20 Best Digital Menu Templates for Restaurants", 
            "March 14, 2023", 
            "https://fitsmallbusiness.com/digital-menu-templates/")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/HotelsThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/HotelsLogo.svg", 
            "How to Maximize Hotel Restaurant Menus", 
            "June 7, 2021", 
            "https://hotelsmag.com/news/how-to-maximize-hotel-restaurant-menus/")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/PMQThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/PMQLogo.png", 
            "6 Creative Uses for QR Codes at Your Pizzeria", 
            "December 2020", 
            "https://www.pmq.com/6-creative-uses-for-qr-codes-at-your-pizzeria/",
            "white")}

            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/QSRThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/QSRLogo.svg", 
            "How to Design the Best Sandwich Board for Your Restaurant", 
            "August 31, 2020", 
            "https://www.qsrmagazine.com/outside-insights/how-design-best-sandwich-board-your-restaurant")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/APThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/APLogo.webp", 
            "MustHaveMenus Forecasts How Restaurants Will Rethink Menus During New Era of Restaurant Safety", 
            "April 27, 2020", 
            "https://apnews.com/article/coronavirus-pandemic-business-health-b1498577610058ef3fc062b6c4bab854")}
            {showAllNews && articleItem("https://timber.mhmcdn.com/site/content/press/CisionThumb.webp", 
            "https://timber.mhmcdn.com/site/content/press/CisionLogo.webp", 
            "MustHaveMenus Releases Major Software Update to Give Restaurants Unprecedented Power to Design Menus and Marketing Materials", 
            "January 30, 2020", 
            "https://www.prnewswire.com/news-releases/musthavemenus-releases-major-software-update-to-give-restaurants-unprecedented-power-to-design-menus-and-marketing-materials-300994914.html",)}
            <div className="item"/>
          </div>
        </div>
      </section>

      <section className="four">
        <div className="content">
          <div className="flex">
            <p className="mobile-only"><b>Please direct inquiries to:</b></p>
            <div className="img">
              <div className="jim"/>
            </div>
            <div className="text">
              <p className="desktop-only"><b>Please direct inquiries to:</b></p>
              <h3 className="name">Jim Williams</h3>
              <p className="job-title">CEO<br className="mobile-only"/> @ MustHaveMenus</p>
              <p className="email">jim.williams@musthavemenus.com</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}